<template>
  <div class="userList">
    <user-register />
    <div class="head">
      <span>{{ parseTranslation(USERNAME) }}</span>

      <span v-if="$store.getters.accType === 'Root'">{{
        translations[language][GROUP_NAME]
      }}</span>

      <span v-if="$store.getters.accType !== 'VzAdmin'">{{
        translations[language][CHANGE_ACCOUNT_TYPE]
      }}</span>

      <span>{{ parseTranslation(RESET) }}</span>
    </div>

    <div class="user" v-for="(user, index) in users" :key="user.username">
      <div>
        <div :title="user.username" class="text-size">
          <span
            class="status"
            :class="{ enabled: !user.disabled }"
            :title="user.disabled ? 'disabled' : 'enabled'"
          ></span>

          {{ user.username }}
        </div>
      </div>

      <div v-if="$store.getters.accType === 'Root'">
        <div :title="user.group_name" class="text-size">
          {{ user.group_name }}
        </div>
      </div>

      <user-account :user="user" />

      <div class="d-flex justify-content-center">
        <button class="btn-reset" @click="openModal(index)">
          {{ parseTranslation(RESET) }}
        </button>

        <button class="btn-reset" @click="toggleEnabledStatus(user)">
          {{ parseTranslation(user.disabled ? ENABLE : DISABLE) }}
        </button>

        <div class="modal" :id="`modal${index}`">
          <div>
            <p>{{ parseTranslation(CONFIRM_RESET) }} {{ user.username }}?</p>
            <div>
              <button @click="closeModal(index)">{{ parseTranslation(NO) }}</button>
              <button @click="resetPassword(user.username, index)">
                <span v-if="loading"><Loader color="#fff"/></span>
                <span v-else> {{ parseTranslation(YES) }} </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Loader from '@/components/loading/Loader-3'

import UserAccount from './UserAccount'
import UserRegister from './UserRegister'

import * as translationUserList from './UserList.translations'

const { default: translations, ...translationKeys } = translationUserList

export default {
  name: 'UserList',

  props: {
    users: {
      type: Array,
      default: () => [],
    },
    toggle_user_status: {
      type: Function,
      required: true,
    },
  },

  components: {
    UserAccount,
    UserRegister,
    Loader,
  },

  data() {
    return {
      translations,
      ...translationKeys,
      loading: false,
    }
  },

  methods: {
    ...mapActions(['sendMessage', 'executeSurveyAPICall']),

    async resetPassword(username, index) {
      if (this.loading) return

      this.loading = true

      const success = await this.executeSurveyAPICall({
        path: '/user/force-reset',
        method: 'POST',
        payload: { username },
      })

      if (!success) return (this.loading = false)

      this.sendMessage(success.message)
      this.closeModal(index)

      this.loading = false
    },

    async toggleEnabledStatus({ username, disabled }) {
      if (this.loading) return

      this.loading = true

      const endpoint = disabled ? 'enable' : 'disable'

      const success = await this.executeSurveyAPICall({
        path: `/user/${endpoint}`,
        method: 'POST',
        payload: { username },
      })

      if (!success) return (this.loading = false)

      const newStatus = !disabled

      this.sendMessage(this.parseTranslation(this.STATUS_CHANGE, newStatus))

      this.toggle_user_status(username)

      this.loading = false
    },

    openModal(index) {
      const modal = document.querySelector(`#modal${index}`)
      modal.style.display = 'flex'
    },

    closeModal(index) {
      const modal = document.querySelector(`#modal${index}`)
      modal.style.display = 'none'
    },
  },
  computed: {
    // ordenar em ordem alfabética em um array em um v-for
    orderedUsers() {
      function compare(a, b) {
        if (a.group_name.toLowerCase() < b.group_name.toLowerCase()) return -1
        return 0
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.users.sort(compare)
    },
  },
}
</script>

<style lang="scss" scoped>
.status {
  @include boxSizing(10);
  display: inline-block;
  margin-left: 8px;
  background: $pink-2;
  border-radius: 50%;

  &.enabled {
    background: $green;
  }
}

.userList {
  display: flex;
  width: 90%;
  margin: 0 auto;
  flex-direction: column;

  div.head,
  div.user {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    overflow-x: auto;
    overflow-y: hidden;
    &:last-child {
      margin-bottom: 0;
    }
  }
  div.head {
    margin: 40px 0 30px;
    span {
      @include tipography(24);
      margin: 0 auto;
      flex: 1 0 25%;
      text-align: center;
      @include d(s) {
        font-size: 1rem;
      }
    }
  }
  div.user {
    div {
      @include tipography(16);
      margin: 0 auto;
      flex: 1 0 25%;
      text-align: center;
    }
    padding: 10px 0 15px;
    border-bottom: 2px solid $gray-9;
  }
  .light & {
    div.head {
      span {
        color: $gray-6;
      }
    }
    div.user {
      div {
        color: $gray-6;
      }
    }
  }
}

.btn-reset {
  @include btn-style;
  display: unset;
  text-transform: initial;
  padding: 5px 17px;
  margin: 5px 10px;
  width: unset;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  // z-index: 999999;
  animation: show 0.5s forwards;
  > div {
    position: fixed;
    top: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 300px;
    padding: 20px;
    background: #fff;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.4);
    @include tipography(16);
    color: $main-two;
    p {
      margin: 0;
      color: #696969;
    }

    div {
      margin-top: 20px;
      button {
        border: none;
        border-radius: 3px;
        margin-top: 15px;
        padding: 10px 20px;
        letter-spacing: 3px;
        text-transform: uppercase;
        font-weight: bold;
        cursor: pointer;
        @include tipography(15);
        &:focus {
          outline: none;
        }
        &:nth-last-of-type(1) {
          background: $blue;
          margin-left: 15px;
        }
        &:nth-last-of-type(2) {
          color: $gray-2;
          background: $gray-light;
        }
      }
    }
  }
}
.text-size {
  max-width: 27ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 5px;
}

@media (max-width: 576.98px) {
  .userList {
    overflow-x: auto;
    overflow-y: hidden;
    div.head,
    div.user {
      width: 1000px;
    }
  }
}
</style>
